import styles from "@/components/mvp/DemoOfferDecyzyjna.module.css";

type DemoOfferDecyzyjnaProps = {
  onClose: () => void;
};

const rows = [
  ["Malowanie ścian (3 pokoje, grunt + 2 warstwy)", "2 200 zł"],
  ["Malowanie sufitów", "650 zł"],
  ["Szpachlowanie i naprawa ubytków", "800 zł"],
  ["Gruntowanie powierzchni", "420 zł"],
  ["Zabezpieczenie mebli i podłóg", "380 zł"],
  ["Sprzątanie po pracach", "350 zł"],
];

export function DemoOfferDecyzyjna({ onClose }: DemoOfferDecyzyjnaProps) {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Podgląd oferty decyzyjnej">
      <button type="button" className={styles.close} onClick={onClose}>
        × Zamknij
      </button>

      <div className={styles.shell}>
        <article className={styles.page}>
          <div className={`${styles.annotation} ${styles.priceNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Cena na pierwszym miejscu</span>
          </div>
          <div className={`${styles.annotation} ${styles.tableNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Tylko wartość pozycji - bez ilości</span>
          </div>
          <div className={`${styles.annotation} ${styles.footerNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Warunki w skrócie</span>
          </div>

          <header className={styles.header}>
            <div>
              <p className={styles.kicker}>Oferta decyzyjna</p>
              <h1>Malowanie mieszkania</h1>
              <p className={styles.meta}>Anna Wiśniewska · ul. Lipowa 8 m. 3, Pruszków</p>
            </div>
            <div className={styles.dateBox}>
              <span>Data</span>
              <strong>11.07.2025</strong>
              <span>Ważna 14 dni</span>
            </div>
          </header>

          <section className={styles.priceBlock}>
            <span>Razem do zapłaty</span>
            <strong>4 800 zł</strong>
            <p>Zakres prac po oględzinach lokalu.</p>
          </section>

          <section className={styles.tableSection}>
            <h2>Zakres i wartość prac</h2>
            <table>
              <thead>
                <tr>
                  <th>Pozycja</th>
                  <th>Wartość</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(([name, total]) => (
                  <tr key={name}>
                    <td>{name}</td>
                    <td>{total}</td>
                  </tr>
                ))}
                <tr className={styles.totalRow}>
                  <td>RAZEM</td>
                  <td>4 800 zł</td>
                </tr>
              </tbody>
            </table>
          </section>

          <footer className={styles.conditions}>
            <div>
              <span>Materiały</span>
              <strong>po stronie wykonawcy</strong>
            </div>
            <div>
              <span>Płatność</span>
              <strong>50% zaliczka, reszta po odbiorze</strong>
            </div>
            <div>
              <span>Gwarancja</span>
              <strong>12 miesięcy</strong>
            </div>
            <div>
              <span>Termin realizacji</span>
              <strong>4-5 dni roboczych</strong>
            </div>
          </footer>
        </article>
      </div>
    </div>
  );
}
